import React from "react";
import T from "../TheTool";
//from GUI_ButtonSet

function GUI_2Buttons(props) {
	var label1 = T.getValue(props.label1, "Click1");
	var label2 = T.getValue(props.label2, "Click2");
	var ratio1 = T.getValue(props.ratio1, 1);
	var ratio2 = T.getValue(props.ratio2, 3);
	return (
		<div>
			<div className="btn-group" style={{ marginTop: "1em" }}>
				<button
					onClick={() => props.buttonClick1()}
					className="btn btn__primary btn__lg"
					// width="20%"
					style={{ flex: ratio1, height: 50 }}
				>
					{label1}
				</button>
				<button
					onClick={() => props.buttonClick2()}
					className="btn btn__primary btn__lg"
					style={{ flex: ratio2, height: 50 }}
				>
					{label2}
				</button>
			</div>
		</div>
	);
}

export default GUI_2Buttons;
